import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';
import { TrackingLink } from 'lib/app/tracking-link';
import { CdnImagePath } from 'lib/cdn-image-path';
import LocaleContext from 'lib/locale-context';
import usePlatform, { PlatformType } from 'lib/use-platform';

import { onClickAboutCTA } from 'containers/events';

import PageSectionCta from 'components/page/sections/page-section-cta';

export const VideoChatBlockTwoContainer: FunctionComponent = () => {
  const lang = React.useContext(LocaleContext);

  const imagePath = `${CdnImagePath}/bumble/l-assets/${lang}/features/VideoChat-Howtovideochat.jpg`;

  const platform = usePlatform();
  // JS-30493: Bumble Web is discontinued, so every platform - including the
  // ie11/edge/unknown fallbacks that used to link to sign-in - now points at
  // the app download link.
  const ctaLink: { [key in PlatformType]: string } = {
    [PlatformType.ios]: TrackingLink.APPSFLYER_LINK,
    [PlatformType.android]: TrackingLink.APPSFLYER_LINK,
    [PlatformType.ie11]: TrackingLink.APPSFLYER_LINK,
    [PlatformType.edge]: TrackingLink.APPSFLYER_LINK,
    [PlatformType.unknown]: TrackingLink.APPSFLYER_LINK,
  };

  const props = {
    imagePosition: 'left',
    imageSrc: imagePath,
    imageAlt: '',
    title: features.audioCalls.lxAudioCallsTwoBlockTitle,
    text: features.audioCalls.lxAudioCallsTwoBlockBodyText,
    actionText: features.audioCalls.lxFeaturesTryItNowCta,
    actionUrl: ctaLink[platform],
  };

  return (
    <PageSectionCta
      title={props.title}
      /**
       * Fix language based code
       */
      // titleLang={'en'}
      text={props.text}
      action={{
        text: props.actionText,
        href: props.actionUrl,
        onClick: onClickAboutCTA,
      }}
      image={{
        src: props.imageSrc,
        objectPosition: props.imagePosition,
        inlinePosition: 'start',
      }}
      color="yellow"
    />
  );
};
